import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import type { UserRole } from './useUserRole';

export function useDefaultLLM(role: UserRole) {
  const [defaultModel, setDefaultModel] = useState<string>('openai/gpt-4o-mini');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDefaultModel = async () => {
      if (!role) {
        setDefaultModel('openai/gpt-4o-mini');
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('user_role_llm_config')
          .select('default_model')
          .eq('role', role)
          .single();

        if (error) {
          console.error('Error fetching default LLM:', error);
          setDefaultModel('openai/gpt-4o-mini');
        } else if (data) {
          setDefaultModel(data.default_model);
        }
      } catch (error) {
        console.error('Error in useDefaultLLM:', error);
        setDefaultModel('openai/gpt-4o-mini');
      } finally {
        setLoading(false);
      }
    };

    fetchDefaultModel();
  }, [role]);

  return { defaultModel, loading };
}
